import inputTypes from '../operator-selector/supported-input-types';

export function normalizeInputType(type) {

  if (type === inputTypes.DATE_TIME) {
    return 'datetime-local';
  }

  return 'date';

}